import { render, staticRenderFns } from "./PersonalCabinetAccess.vue?vue&type=template&id=35907d53&scoped=true&"
import script from "./PersonalCabinetAccess.vue?vue&type=script&lang=js&"
export * from "./PersonalCabinetAccess.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCabinetAccess.vue?vue&type=style&index=0&id=35907d53&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35907d53",
  null
  
)

export default component.exports